import classes from './ChatWidget.module.scss'
import { IconBot } from './icons'

interface Props {
  /** Nokta dizisinin yanındaki etiket. Tanıtımda "yanıt üretiyor" yanlış okunur (soru yok). */
  label?: string
}

/** "Yanıt üretiliyor" durumu: kırmızı zıplayan noktalar + etiket + shimmer iskelet satırları. */
export default function TypingIndicator({ label = 'B-Gini yanıt üretiyor…' }: Props) {
  return (
    <div className={classes.msgRow} role='status'>
      <span className={classes.botAvatar}>
        <IconBot />
      </span>
      <div className={`${classes.bubble} ${classes.bubbleBot} ${classes.bubbleTyping}`}>
        <div className={classes.typingRow}>
          <div className={classes.typingDots} aria-hidden='true'>
            <span className={classes.typingDot} />
            <span className={classes.typingDot} />
            <span className={classes.typingDot} />
          </div>
          <span className={classes.typingLabel}>{label}</span>
        </div>
        <div className={`${classes.skeletonLine} ${classes.skeletonW75}`} aria-hidden='true' />
        <div className={`${classes.skeletonLine} ${classes.skeletonW50}`} aria-hidden='true' />
        <span className={classes.srOnly}>Yanıt üretiliyor</span>
      </div>
    </div>
  )
}
